import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import SettingsPaynowDiscountsScreen from "../../../container/Settings/SettingsPaynowDiscountsScreen";
import CreateSettingsPaynowDiscounts from "../../../container/Settings/SettingsPaynowDiscountsScreen/CreateSettingsPaynowDiscounts";

const SettingsPaynowDiscountsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.SETTINGS_PAYNOWDISCOUNTS.HOME}
          element={
            <SettingsPaynowDiscountsScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.SETTINGS_PAYNOWDISCOUNTS.CREATE}
          element={<CreateSettingsPaynowDiscounts />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.SETTINGS_PAYNOWDISCOUNTS.EDIT}
          element={<CreateSettingsPaynowDiscounts isEdit={true} />}
        />
      )}
    </>
  );
};

export default SettingsPaynowDiscountsRoutes;
